import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectUser } from '../reducers/user.selectors';

/**
 * Returns true if the current user is part of the LB migration cohort.
 */
const useIsLBUser = (): boolean => {
	const user = useSelector(selectUser);

	return useMemo(() => {
		return !!user?.lbMigration?.auth?.migrated;
	}, [user?.lbMigration?.auth?.migrated]);
};

export default useIsLBUser;
